import React from "react";
import * as XLSX from "xlsx";
import {
    useDataProvider,
    useListContext,
    Button,
    Filter,
    DateField,
    TextField,
    NumberField,
    Datagrid
} from 'react-admin';
import DownloadIcon from '@mui/icons-material/Download';

const ExportExcelButton = ({total, fileName, sheetName}) => {
    const {filterValues} = useListContext();
    const dataProvider = useDataProvider();

    let w_fileName, w_sheetName;
    fileName ? w_fileName = fileName + ".xlsx" : w_fileName = 'planilla.xlsx';
    sheetName ? w_sheetName = sheetName : w_sheetName = 'Hoja 1';

    const handleClick = () => {
        // Data para exportar
        dataProvider.getList(
            'ContratacionEncuadreGerente',
            {
                filter: {
                    id_unidad_negocio: filterValues.id_unidad_negocio,
                    id_unidad_area: filterValues.id_unidad_area,
                    id_contratacion_tipo: filterValues.id_contratacion_tipo,
                    id_estado_encuadre: filterValues.id_estado_encuadre,
                    contratacion_ano_ing: filterValues.contratacion_ano_ing,
                    id: filterValues.id,
                    q: filterValues.q
                },
                sort: {field: 'id', order: 'ASC'},
                pagination: {page: 1, perPage: total},
            },)
            .then(({data}) => {
                downloadExcel(data);
            })
            .catch(error => {
                console.log(error)
            });
    };

    // JN Creo un nuevo JSON sólo con los campos que quiero mostrar en el excel

    // Ajusta el ancho de las columnas automaticamente segun el contenido
    const fitToColumn = data_export => {
        const columnWidths = [];
        for (const property in data_export[0]) {
            columnWidths.push({wch: Math.max(property ? property.toString().length : 0, ...data_export.map(obj => obj[property] ? obj[property].toString().length : 0))});
        }
        return columnWidths;
    };

    const downloadExcel = (data) => {
        let data_export = data.map(({
                                        id,
                                        expediente_referencia_gde,
                                        contratacion_d,
                                        concepto_descripcion,
                                        unidad_negocio,
                                        unidad_area_d,
                                        importe_contratacion_pesos,
                                        estado_encuadre,
                                        cumplido_total_pasos


                                    }) => ({
            id,
            expediente_referencia_gde,
            contratacion_d,
            concepto_descripcion,
            unidad_negocio,
            unidad_area_d,
            importe_contratacion_pesos,
            estado_encuadre,
            cumplido_total_pasos
        }));

        const worksheet = XLSX.utils.json_to_sheet(data_export);
        worksheet['!cols'] = fitToColumn(data_export);

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, w_sheetName);
        XLSX.utils.sheet_add_aoa(worksheet, [["ID", "Expediente", "Tipo", "Concepto", "Unidad Negocio", "Unidad Área", "Contratacion $", "Estado Actual", "Etapas Cumplidas"]], {origin: "A1"});

        XLSX.writeFile(workbook, w_fileName);
    };
    return (
        <Button
            onClick={() => handleClick()}
            label="excel"
        >
            <DownloadIcon/>
        </Button>
    )
};

export default ExportExcelButton;
